import { render } from "./TabelaAccordion.vue?vue&type=template&id=919d0be2&scoped=true&ts=true"
import script from "./TabelaAccordion.vue?vue&type=script&lang=ts"
export * from "./TabelaAccordion.vue?vue&type=script&lang=ts"

import "./TabelaAccordion.vue?vue&type=style&index=0&id=919d0be2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-919d0be2"]])

export default __exports__